import { motion, useReducedMotion } from 'framer-motion';

/* Infinite horizontal marquee.
   The track renders `children` four times. The animation shifts the track
   left by exactly 50% of its width (= two copies) and repeats — so the
   copy that scrolls into view is pixel-identical to the one leaving, giving
   a genuinely seamless loop with no mid-cycle jump. Rendering four copies
   guarantees the visible span always overflows the viewport on wide screens. */
export default function Marquee({ children, duration = 24, className, style }) {
  const reduce = useReducedMotion();
  const content = (
    <span style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
      {children}
    </span>
  );
  return (
    <div className={className} style={{ overflow: 'hidden', whiteSpace: 'nowrap', display: 'flex', ...style }}>
      <motion.div
        style={{ display: 'inline-flex', willChange: 'transform' }}
        animate={reduce ? undefined : { x: ['0%', '-50%'] }}
        transition={{ duration, repeat: Infinity, ease: 'linear' }}
      >
        {content}
        {content}
        {content}
        {content}
      </motion.div>
    </div>
  );
}
